import { nextTick } from "vue";
import { useResultsV2CardsStore } from "@stores/survey/resultsV2/resultsV2.cards";

// Jumping to a card that sits in a collapsed section would target an element that
// isn't rendered, so reveal it first and let Vue paint before measuring. Both expands
// are no-ops when they don't apply: expandSectionForCard for a card inside a section,
// expandSection for when the target is the section card itself.
export async function revealAndScrollToCard(cardId) {
  const cardsStore = useResultsV2CardsStore();
  cardsStore.expandSectionForCard(cardId);
  cardsStore.expandSection(cardId);
  await nextTick();
  const el = document.getElementById(`results-card-${cardId}`);
  if (el) scrollCardIntoView(el);
}

export function scrollCardIntoView(cardEl) {
  const scroller = cardEl.closest(".overflow-y-auto");
  if (!scroller) {
    cardEl.scrollIntoView({ behavior: "smooth", block: "start" });
    return;
  }
  scroller.scrollTo({ top: flowTop(cardEl, scroller), behavior: "instant" });
  setTimeout(() => {
    if (!cardEl.isConnected) return;
    scroller.scrollTo({ top: flowTop(cardEl, scroller), behavior: "smooth" });
  }, 100);
}

function flowTop(cardEl, scroller) {
  const isSticky = getComputedStyle(cardEl).position === "sticky";
  if (isSticky) cardEl.style.position = "static";
  const top =
    cardEl.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop;
  if (isSticky) cardEl.style.position = "";
  return top;
}
